import type { FrameRepository, RawFrameData } from '../../domain/ports/FrameRepository';

const BASE_URL = process.env.DATASET_BASE_URL ?? 'https://static.scale.com/uploads/pandaset-challenge';
const MAX_RETRIES = 3;
const BACKOFF_MS = [1000, 2000, 4000];

export class CDNFrameRepository implements FrameRepository {
  async fetchFrame(frameId: number): Promise<RawFrameData> {
    const padded = frameId.toString().padStart(2, '0');
    const url = `${BASE_URL}/frame_${padded}.json`;

    let lastError: Error | null = null;

    for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return await response.json() as RawFrameData;
      } catch (error) {
        lastError = error instanceof Error ? error : new Error(String(error));

        if (attempt < MAX_RETRIES) {
          await new Promise(resolve => setTimeout(resolve, BACKOFF_MS[attempt]));
        }
      }
    }

    throw lastError!;
  }
}
